import { FormItemRule } from 'element-plus'

const RULES_ERRORS = {
  emailRequired: 'Введите адрес эл.почты',
  emailIncorrect: 'Некорректный адрес эл.почты',
  passwordRequired: 'Введите пароль',
  passwordTooShort: 'Пароль должен содержать от 8 симоволов',
  passwordTooLong: 'Пароль должен содержать до 255 символов',
  passwordTooEasy: 'Пароль слишком простой',
  passwordHasNotLetter: 'Пароль должен содержать хотя бы одну букву',
  passwordHasSpace: 'В пароле не должно быть пробелов',
  repeatPassword: 'Повторите пароль',
  surnameRequired: 'Введите фамилию',
  nameRequired: 'Введите имя',
  dateRequired: 'Введите дату рождения',
  positionRequired: 'Введите должность',
  roleRequired: 'Укажите роль',
  organizationsRequired: 'Укажите клиники',
  organizationNameRequired: 'Введите название',
  addressRequired: 'Введите адрес',
}

export const COMMON_RULES: Record<string, FormItemRule> = {
  emailRequired: {
    required: true,
    message: RULES_ERRORS.emailRequired,
    trigger: 'blur',
  },
  emailIncorrect: {
    type: 'email',
    message: RULES_ERRORS.emailIncorrect,
    trigger: 'blur',
  },
  passwordRequired: {
    required: true,
    message: RULES_ERRORS.passwordRequired,
    trigger: 'blur',
  },
  passwordTooShort: {
    min: 8,
    message: RULES_ERRORS.passwordTooShort,
    trigger: 'blur',
  },
  passwordTooLong: {
    max: 255,
    message: RULES_ERRORS.passwordTooLong,
    trigger: 'blur',
  },
  passwordHasNotLetter: {
    message: RULES_ERRORS.passwordHasNotLetter,
    validator: (_, password) => {
      return /[a-zA-Zа-яёA-ЯЁ]/.test(password)
    },
    trigger: 'blur',
  },
  passwordHasSpace: {
    message: RULES_ERRORS.passwordHasSpace,
    validator: (_, password) => {
      return password.indexOf(' ') < 0
    },
    trigger: 'blur',
  },
  repeatPassword: {
    required: true,
    message: RULES_ERRORS.repeatPassword,
    trigger: 'blur',
  },
  surnameRequired: {
    required: true,
    message: RULES_ERRORS.surnameRequired,
    trigger: 'blur',
  },
  nameRequired: {
    required: true,
    message: RULES_ERRORS.nameRequired,
    trigger: 'blur',
  },
  dateRequired: {
    required: true,
    message: RULES_ERRORS.dateRequired,
    trigger: 'blur',
  },
  positionRequired: {
    required: true,
    message: RULES_ERRORS.positionRequired,
    trigger: 'blur',
  },
  roleRequired: {
    required: true,
    message: RULES_ERRORS.roleRequired,
    trigger: 'blur',
  },
  organizationsRequired: {
    required: true,
    message: RULES_ERRORS.organizationsRequired,
    trigger: 'blur',
  },
  organizationNameRequired: {
    required: true,
    message: RULES_ERRORS.organizationNameRequired,
    trigger: 'blur',
  },
  addressRequired: {
    required: true,
    message: RULES_ERRORS.addressRequired,
    trigger: 'blur',
  },
} as const
